export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const USERNAME_EXISTS = "USERNAME_EXISTS";
// export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';
